import { isValidDateString } from './isValidDateString';

/**
 * Gives us type safety for a date string like '2020-07-31'. After using toDateString() on such a
 * string, we can pass it to other functions and it will be safe to assume it is a DateString type.
 * Based on: https://spin.atomicobject.com/2017/06/19/strongly-typed-date-string-typescript/
 */
export const toDateString = (date: string): DateString => {
    if (isValidDateString(date)) {
        return date;
    }
    throw new Error(`Invalid date string: ${date}`);
};
